import { Domain } from '@com.capgemini.cn/crbr-api-server'
import { setApiUrl } from '@/api/api'

export const requestGetApiUrl = () => { // 动态获取APIURL地址
  return new Promise((resolve, reject) => {
    // 动态获取后台服务API请求URL
    Domain.getServiceMap('serviceMapUrl', undefined, true).then(res => {
      if (res.data) {
        setApiUrl(res.data)
        resolve()
      }
    }).catch(err => {
      alert(err.msg)
    })
  })
}



// WEBPACK FOOTER //
// ./src/apiUrl.js